// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1p8cP","empty":"ModalGraph_empty__2aOWP"};